/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import MainLayout from '../Layouts/Mainlayout'
import { useParams } from 'react-router-dom'
import EditRequestImport from './EditRequestImport';

function EditRequestWrapper(): JSX.Element {
    const param = useParams();
    const { id } = param;
    return (
        <div className="flex flex-row justify-start">
            <MainLayout>
                <EditRequestImport jobId={id} />
            </MainLayout>
        </div>
    )
}

export default EditRequestWrapper